import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Genererer Wikipedia-lenke for norsk kommune. */
export function getWikipediaUrl(municipalityName: string): string {
  const slug = municipalityName.replace(/\s+/g, '_')
  return `https://no.wikipedia.org/wiki/${encodeURIComponent(slug)}`
}
